import { Services } from '../services'

export class FuelEntry {
    id!: string
    indexId!: number
    source!: string
    vehicle!: string
    gallons!: number
    lifetimeMeter!: number
    lifetimeMeterId!: string
    date!: Date
    userId!: string
    userName!: string
    meter!: number
    jobId!: string
    fuelTypeIn!: string
    fuelTypeOut!: string
    validationMessage!: string
    isInverse = false
    sequence!: number

    monthDate!: Date
    costCode!: number
    description!: string

    account!: number
    avgPrice!: number
    amount!: number

    protected $setProperties(source: any, services: Services): void {
        source.monthDate = FuelEntry.getLastDayOfMonth(source.date)

        let costCode = 32
        if (source.source && services.data.fuelRecordDefaults) {
            const match = services.data.fuelRecordDefaults.items.filter(x => x.equipment == source.source)
            if (match.length > 0) {
                costCode = match[0].costCode
            }
        }
        source.costCode = costCode

        let costType = 30
        if (source.source && services.data.fuelRecordDefaults) {
            const match = services.data.fuelRecordDefaults.items.filter(x => x.equipment == source.source)
            if (match.length > 0) {
                costType = match[0].costType
            }
        }
        source.costType = costType

        source.description = 'FROM ' + source.source + ' TO ' + source.vehicle

        let account = 1360
        if (source.source && services.data.fuelRecordDefaults) {
            const match = services.data.fuelRecordDefaults.items.filter(x => x.equipment == source.source)
            if (match.length > 0) {
                account = match[0].offsetGl
            }
        }
        source.account = account

        let avgPrice = 0
        if (this.date && services.data.fuelPrices) {
            const month = source.date.getMonth()
            const year = source.date.getFullYear()
            const match = services.data.fuelPrices.items.find(
                x => x.fuelDate.getMonth() === month && x.fuelDate.getFullYear() === year && x.fuelType === source.fuelTypeOut,
            )
            if (match) {
                avgPrice = match.fuelPrice
            } else {
                const records = services.data.fuelPrices.items
                    .filter(x => x.fuelType === source.fuelTypeOut)
                    .orderByDescending(x => x.fuelDate)
                if (records.length > 0) avgPrice = records[0].fuelPrice
            }
        }
        source.avgPrice = avgPrice

        source.amount = source.avgPrice * source.gallons
    }

    private static getLastDayOfMonth(inputDate: Date): Date {
        const year = inputDate.getFullYear()
        const month = inputDate.getMonth()

        // Create a new date representing the first day of the next month
        const nextMonth = new Date(year, month + 1, 1)

        // Subtract one day to get the last day of the current month
        const lastDay = new Date(nextMonth)
        lastDay.setDate(nextMonth.getDate() - 1)

        return lastDay
    }

    static addTableProps(fuelEntry: any) {
        fuelEntry.batch = 828
        fuelEntry.transType = 'Fuel'
        fuelEntry.um = 'GAL'
    }
}
